<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_283_38857)">
      <rect width="20" height="20" rx="10" fill="#0D87EF"/>
      <path d="M9.99998 5.33301V14.6663M5.33331 9.99967H14.6666" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_283_38857">
        <rect width="20" height="20" rx="10" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
